const renderPDFCheckBox = ({ checked }) => {
  return checked ? 'x' : null;
};

export default renderPDFCheckBox;
